import { FC, useCallback } from 'react'

import { useAppDispatch } from 'cng-common/hooks/useAppDispatch'
import { Button } from 'core-components/library/button'
import { addBlankItem } from 'partner360/features/assortment/assortmentSlice'

import { IAddAssortmentItemProps } from './models'

import styles from './AddAssortmentItem.module.scss'

export const AddAssortmentItem: FC<IAddAssortmentItemProps> = ({ assortmentGroupId }) => {
  const dispatch = useAppDispatch()

  const handleAddBlankItem = useCallback(() => {
    dispatch(addBlankItem(assortmentGroupId))
  }, [dispatch, assortmentGroupId])

  return (
    <Button variant="outlined" className={styles.crossIcon} onClick={handleAddBlankItem}>
      <i className="kbase kbase-add" />
    </Button>
  )
}
